import xml2js, { ParserOptions } from 'xml2js';
import { parseBooleans, parseNumbers } from 'xml2js/lib/processors';
import {
  TApiaFieldPropsObj,
  TFieldScriptEvents,
  TFieldServerEvents,
  TNotificationMessage,
} from '../types';
import { AxiosResponse } from 'axios';

export const processAjaxEventTagNames = (name: string): string => {
  return name;
};

export const processAjaxEventAttrNames = (name: string): string => {
  return name;
};

export interface TSessionExceptions {
  exception: {
    content: string;
    text: string;
  };
}

export const processAjaxEventResponse = (
  value: unknown,
  name: string,
): string | unknown => {
  if (name === 'v' && value === 'T') return true;
  if (name === 'v' && value === 'F') return false;
  return value;
};

export const getJSObjFromXML = (
  xml: XMLDocument | string,
): Record<string, unknown> => {
  let objJS: TNotificationMessage | null = null;

  const parser = new xml2js.Parser({
    trim: true,
    normalize: true,
    explicitRoot: false,
    mergeAttrs: true,
    explicitArray: false,
    charkey: 'content',
    attrValueProcessors: [
      parseBooleans,
      processStringObj,
      processAjaxEventResponse,
    ],
    tagNameProcessors: [processAjaxEventTagNames],
    attrNameProcessors: [processAjaxEventAttrNames],
  } as ParserOptions);

  parser.parseString(
    xml,
    (err: Error | null, result: Record<string, unknown>) => {
      if (err) {
        console.warn('Error Parsing XML data', err);
      } else {
        objJS = result;
      }
    },
  );
  if (objJS) {
    return objJS;
  }
  return {};
};

export const processStringObj = (
  value: string,
  key: string,
):
  | TApiaFieldPropsObj
  | string
  | number
  | TFieldScriptEvents
  | TFieldServerEvents => {
  /*

   *     ESTAS ENTRADAS VAN A SER NECESARIAS CUANDO SE INCORPORE MODULO DE
   *     EJECUCION AL MONOREPO

  if (key === 'properties') {
    return parseFieldPropertiesObj(jsonDecode(value)) as TApiaFieldPropsObj;
  }
  if (key === 'scriptEvents') {
    return JSON.parse(value) as TFieldScriptEvents;
  }
  if (key === 'serverEvents') {
    return JSON.parse(value) as TFieldServerEvents;
  }
  if (key === 'gridXml') {
    return getJSObjfromXML(he.decode(value).replaceAll('&', '&amp;'));
  } */
  if (key === 'value' && typeof value === 'number' && Number.isNaN(value)) {
    return '';
  }
  if (key === 'valueType' && typeof value === 'string' && value === 'null') {
    return '';
  }
  if (
    (key === 'cols' ||
      key === 'rows' ||
      key === 'x' ||
      key === 'y' ||
      key === 'length') &&
    typeof value === 'string'
  ) {
    return parseNumbers(value);
  }
  return value;
};

export const parseXmlAsync = async <T>(xml: string): Promise<T> => {
  const parser = new xml2js.Parser({
    trim: true,
    normalize: true,
    explicitRoot: false,
    mergeAttrs: true,
    explicitArray: false,
    charkey: 'content',
    attrValueProcessors: [
      parseBooleans,
      processStringObj,
      processAjaxEventResponse,
    ],
    tagNameProcessors: [processAjaxEventTagNames],
    attrNameProcessors: [processAjaxEventAttrNames],
  } as ParserOptions);

  const result = await new Promise<T>((resolve, reject) => {
    parser.parseString(xml, (err: Error | null, innerResult: T) => {
      if (err) {
        console.log(xml);
        reject(err);
      } else {
        resolve(innerResult);
      }
    });
  });

  return result;
};

export const parseXMLRequestResponse = (
  response: AxiosResponse<unknown, unknown>,
): Record<string, unknown> => {
  // if (response.config.data) {
  //   parse(response.config.data as string);
  // }
  const requestResponse = response.data;
  const xmlToJSOBj = getJSObjFromXML(requestResponse as XMLDocument);

  if (xmlToJSOBj) {
    return xmlToJSOBj;
  }
  return {};
};
